/* Localize campaign thresholds, never calculate or apply a checkout discount. */
(function () {
  'use strict';
  function rateFor(currency) {
    if (currency === 'USD') return 1;
    var current = window.Shopify && window.Shopify.currency;
    var rate = Number(current && current.rate);
    return current && current.active === currency && Number.isFinite(rate) && rate > 0 ? rate : null;
  }
  function digits(currency) {
    return new Intl.NumberFormat('en', { style: 'currency', currency: currency }).resolvedOptions().maximumFractionDigits;
  }
  function convert(cents, rate, currency) {
    // Shopify cart values use 100 subunits even for JPY. Round thresholds UP
    // to an actual payable unit so a display never promises an early reward.
    var scale = Math.pow(10, digits(currency));
    return Math.ceil((Number(cents) / 100) * rate * scale - 1e-8) / scale * 100;
  }
  function money(cents, currency, locale) {
    return new Intl.NumberFormat(locale || 'en', {
      style: 'currency', currency: currency, currencyDisplay: 'symbol',
      minimumFractionDigits: 0, maximumFractionDigits: digits(currency)
    }).format(cents / 100) + ' ' + currency;
  }
  function fill(text, values) {
    return String(text || '').replace(/\[(\w+)\]/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }
  if (!customElements.get('hk-currency-amount')) customElements.define('hk-currency-amount', class extends HTMLElement {
    connectedCallback() {
      var currency = this.dataset.currency, rate = rateFor(currency);
      if (rate === null) return;
      this.textContent = money(convert(this.dataset.usdCents, rate, currency), currency, this.dataset.locale);
    }
  });
  if (!customElements.get('hk-local-rewards')) customElements.define('hk-local-rewards', class extends HTMLElement {
    connectedCallback() {
      var currency = this.dataset.currency, rate = rateFor(currency);
      var template = this.querySelector('template');
      if (rate === null || !template || this.dataset.ready) return;
      var config;
      try { config = JSON.parse(this.dataset.config); } catch (_) { return; }
      var content = template.content.cloneNode(true);
      var format = (cents) => money(cents, currency, this.dataset.locale);
      var tiers = config.tiers.map((tier) => ({ percent: tier.percent, threshold: convert(tier.threshold, rate, currency) }));
      var current = null, next = null, reached = 0;
      tiers.forEach((tier) => { if (config.subtotal >= tier.threshold) { current = tier; reached++; } else if (!next) next = tier; });
      var percent = current ? current.percent : 0;
      var applications = config.applications.filter((a) => a.total_allocated_amount > 0);
      var applied = applications.some((a) => (!a.type || a.type === 'automatic') && a.value_type === 'percentage' && Number(a.value) === percent && a.title === 'Houndkeep Anniversary — ' + percent + '%');
      var other = applications.some((a) => a.title !== 'Houndkeep Anniversary — ' + percent + '%');
      var say = content.querySelector('[data-local-tier-text]');
      if (say) {
        var message = current ? fill(config.text.reached, { percent: percent }) + ' ' : '';
        message += next ? fill(config.text.next, { percent: next.percent, amount: format(Math.max(0, next.threshold - config.subtotal)) }) : config.text.highest;
        say.textContent = message;
        var journey = content.querySelector('[data-hk-journey]');
        var max = tiers[tiers.length - 1].threshold;
        var progress = Math.min(100, config.subtotal / max * 100);
        journey.dataset.hkProgress = progress;
        journey.dataset.hkMood = applied && !other ? reached : 0;
        journey.style.setProperty('--hk-progress', progress + '%');
        var track = journey.querySelector('[role=progressbar]');
        track.setAttribute('aria-valuenow', Math.round(progress));
        track.setAttribute('aria-valuetext', format(config.subtotal) + ' / ' + format(max));
        var dog = journey.querySelector('.hk-dog');
        if (dog) { for (var i = 0; i <= 3; i++) dog.classList.remove('hk-dog--' + i); dog.classList.add('hk-dog--' + journey.dataset.hkMood); }
        journey.querySelectorAll('[data-local-stop]').forEach((stop, index) => {
          var tier = tiers[index], hit = config.subtotal >= tier.threshold;
          stop.classList.toggle('is-reached', hit);
          stop.style.setProperty('--hk-stop', tier.threshold / max * 100 + '%');
          stop.querySelector('.hk-journey__dot').textContent = hit ? '✓' : '';
          stop.querySelector('[data-local-money]').textContent = format(tier.threshold);
        });
        var status = content.querySelector('[data-local-status]');
        status.textContent = applied ? fill(config.text.applied, { percent: percent }) : other ? config.text.other : config.text.pending;
        status.hidden = !current && !other;
      }
      var shipping = content.querySelector('[data-local-shipping-text]');
      if (shipping) {
        var threshold = convert(config.shipping, rate, currency), qualified = config.total >= threshold;
        var shipProgress = Math.min(100, config.total / threshold * 100);
        shipping.textContent = qualified ? config.text.shipReached : fill(config.text.shipNext, { amount: format(threshold - config.total) });
        var meter = content.querySelector('.hk-meter');
        meter.classList.toggle('hk-meter--complete', qualified);
        meter.setAttribute('aria-valuenow', Math.round(shipProgress));
        meter.setAttribute('aria-valuetext', format(config.total) + ' / ' + format(threshold));
        meter.querySelector('.hk-meter__fill').style.width = shipProgress + '%';
      }
      this.replaceChildren(content);
      this.dataset.ready = 'true';
    }
  });
})();
